module.exports = __webpack_public_path__ + "static/media/8.2.1162818a.zip";